import { IMessageBus } from "@roketus/web-toolkit";
import { getContainer } from "../../diContainer/container";

export const init = () => {
  const messageBus = getContainer().getDependency("messageBus") as IMessageBus;
  messageBus.stream$.subscribe((message) => {
    console.table(message);
  });
};
